export default class Timebar extends Phaser.Group {
  constructor(game) {
    super(game);

    this.bg = this.game.make.image(0, 0, 'foodgame_gui', 'timebar_bg.png');
    this.bar = this.game.make.graphics();
    this.bar.beginFill(0xff00ff);
    this.bar.drawRoundedRect(16, 12, 570, 24, 12);

    this.barMask = this.game.make.graphics();
    this.barMask.beginFill(0xff00ff);
    this.barMask.drawRoundedRect(16, 12, 570, 24, 12);

    this.addChild(this.bg);
    this.addChild(this.bar);
    this.addChild(this.barMask);

    this.bar.mask = this.barMask;
  }

  setValue(value) {
    // this.bar.drawRoundedRect(16, 12, 570 * value, 24, 12);
    value = Math.max(0, value);
    this.barMask.x = -570 * (1 - value);
  }
}



// WEBPACK FOOTER //
// ./js/app/games/food/ui/Timebar.js